<template>
  <div class="google-signin-wrapper">
    <div ref="googleSignInButton"></div>
  </div>
</template>

<script>
import authService from "@/modules/Authentication/service.js";

export default {
  name: "GoogleLogin",
  props: {
    mode: {
      type: String,
      default: "login", // can be 'login' or 'signup'
    },
    OrganizationId: {
      type: [String, Number],
      default: null,
    },
  },
  mounted() {
    this.loadGoogleScript();
  },
  methods: {
    checkResponse(response) {
      // console.log("Google response", response);
      if (response.status === 400) {
        this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          })
          .fire({
            icon: "error",
            title: "Invalid User",
          });
      } else {
        console.log("Google login success");
        this.$router.push({ name: "home" });
      }
    },
    loadGoogleScript() {
      const script = document.createElement("script");
      script.src = "https://accounts.google.com/gsi/client";
      script.async = true;
      script.defer = true;
      script.onload = this.initializeGoogleSignIn;
      document.head.appendChild(script);
    },
    initializeGoogleSignIn() {
      google.accounts.id.initialize({
        client_id: process.env.VUE_APP_GOOGLE_CLIENT_ID,
        callback: this.handleCredentialResponse,
      });
      google.accounts.id.renderButton(this.$refs.googleSignInButton, {
        theme: "outline",
        size: "large",
      });
      // google.accounts.id.prompt();
    },
    handleCredentialResponse(response) {
      this.loading = true;
      const payload = {
        authCode: response.credential,
        type: "Member",
      };

      if (this.OrganizationId) {
        payload.OrganizationId = this.OrganizationId;
      }
      console.log("Google auth payload", payload);
      let promise;
      if (this.mode === "signup") {
        promise = authService.Google.getSignUpToken(payload);
      } else {
        promise = authService.Google.getToken(payload);
      }

      promise
        .then((response) => {
          // this.checkResponse(response);
          this.$emit("login-success", response);
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          console.log("Google auth error", error);
          this.$swal(
            "Login failed!",
            "Please check your email and password.",
            "error"
          );
        });
    },
  },
};
</script>

<style scoped>
.google-signin-wrapper {
  display: flex;
  justify-content: center;
  margin-bottom: 20px; /* optional spacing */
}
</style>